import "./cancel-dispatch-error-modal.css";

import { SvgIcon } from "@tql/ui-components-react/kendo/common";
import { alertTriangle } from "@tql/ui-components-react/untitled/icons";

import { TraxModal } from "~/shared/components/trax-modal/trax-modal.tsx";

export const CancelDispatchErrorModal = ({
	onClose,
	isOpen,
	carrierPhone,
	confirmationNumber,
}: {
	onClose: () => void;
	isOpen: boolean;
	carrierPhone: string | null | undefined;
	confirmationNumber: string | null | undefined;
}) => {
	if (!isOpen) {
		return null;
	}

	return (
		<TraxModal
			className={"cancel-dispatch-error-modal"}
			confirmText={"I understand"}
			onClose={onClose}
			onConfirm={onClose}
			showCancelButton={false}
			showConfirmButton={true}
			showConfirmationButtons={true}
			title={"Cancel Dispatch Error"}
			type={"error"}
		>
			<div className={"cancel-dispatch-error-content"}>
				<div className={"cancel-dispatch-error-message"}>
					<SvgIcon
						icon={alertTriangle}
						size={"xxxlarge"}
						style={{ color: "var(--kendo-color-error)" }}
					/>
					<strong>Dispatch could not be canceled via API.</strong>
				</div>
				<p>Please call the carrier to cancel the dispatch.</p>
				<div className={"cancel-dispatch-error-details"}>
					<div>
						<span>Carrier Phone #: </span>
						<span className={"cancel-dispatch-error-phone"}>
							{carrierPhone ?? "N/A"}
						</span>
					</div>
					<div>Carrier Pickup Confirmation: {confirmationNumber ?? "N/A"}</div>
				</div>
			</div>
		</TraxModal>
	);
};
